/**
 * Extracts a backend-provided error message from an Axios error response body,
 * falling back to the supplied generic message when no usable message is present.
 */
export function backendErrorMessage(error: unknown, fallback: string): string {
  const data = (error as { response?: { data?: { error?: unknown } } })?.response?.data
  return typeof data?.error === 'string' && data.error.length > 0 ? data.error : fallback
}
